import CookiesJS from 'cookies-js';
import {submitHandler} from './submit-handler';

export function initRestoreAction($, apiClient) {
    const $form = $('form.restore-action-form');
    const $password = $form.find('#new_password');
    const $passwordConfirm = $form.find('#new_password_confirm');
    const $submit = $form.find('.action__restore-action');

    function isValid() {
        const p = $password.val();
        const c = $passwordConfirm.val();
        return p.length > 0 && p === c;
    }

    function updateSubmitState() {
        $submit.prop('disabled', !isValid());
    }

    $password.on('keyup', updateSubmitState);
    $passwordConfirm.on('keyup', updateSubmitState);

    submitHandler('form.restore-action-form .action__restore-action', async function () {
        if (!isValid()) return;
        const params = {
            new_password: $password.val(),
            new_password_confirm: $passwordConfirm.val(),
        };
        const url = new URL(document.location.href);
        const code = url.pathname.split('/')[2];
        const result = await apiClient.changePasswordWithCode(code, params);
        if (!result.token) {
            throw new Error('Auth failed.');
        }
        if (!result.user) {
            throw new Error('Auth failed.');
        }
        CookiesJS.set('auth_token', result.token, { expires: 2147483647 });
        const user = await apiClient.getSelf(result.token);
        if (user.productsExcluded) {
            document.location.href='/';
        } else {
            document.location.href='/exclude';
        }
    });
}
